module.exports = __webpack_public_path__ + "img/sbzc_21.25804fb6.jpg";